import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { wakeForestConfig } from "./data";

export default function WakeForestPage() {
  return <CityPageTemplate config={wakeForestConfig} />;
}